
import { fromEventPattern } from 'rxjs';

import { IModeService } from '@workbench-stack/core';
import { injectable } from 'inversify';
import { Observable } from 'rxjs';
import { IMode } from '@vscode-alt/monaco-editor/esm/vs/editor/common/modes';
import { StaticServices } from '@vscode-alt/monaco-editor/esm/vs/editor/standalone/browser/standaloneServices';
import { IModeService as IEditorModeService } from '@vscode-alt/monaco-editor/esm/vs/editor/common/services/modeService';
import { URI } from '@vscode-alt/monaco-editor/esm/vs/base/common/uri';
import { Event } from '@vscode-alt/monaco-editor/esm/vs/base/common/event';

/**
 * Creates a {@link ModeService} instance.
 */
@injectable()
export class ModeService implements IModeService {

    public onDidCreateMode: Observable<IMode>;

    private static _modeService: IEditorModeService;
    constructor() {
        this.onDidCreateMode = fromEventPattern<IMode>(StaticServices.modeService.get().onDidCreateMode);
    }
    onLanguagesMaybeChanged: Event<void>;

    public static getModeService() {
        if (!this._modeService) {
            this._modeService = StaticServices.modeService.get();
        }
        return this._modeService;
    }

    public getExtensions(alias: string) {
        return ModeService.getModeService().getExtensions(alias);
    }

    public getFilenames(alias: string) {
        return ModeService.getModeService().getFilenames(alias);
    }

    public getModeId(commaSeparatedMimetypesOrCommaSeparatedIds: string) {
        return ModeService.getModeService().getModeId(commaSeparatedMimetypesOrCommaSeparatedIds);
    }

    public getMimeForMode(modeId: string) {
        return ModeService.getModeService().getMimeForMode(modeId);
    }

    public getLanguageName(modeId: string) {
        return ModeService.getModeService().getLanguageName(modeId);
    }

    public getModeIdForLanguageName(alias: string) {
        return ModeService.getModeService().getModeIdForLanguageName(alias);
    }

    public getModeIdByFilepathOrFirstLine(resource: URI | null, firstLine?: string) {
        return ModeService.getModeService().getModeIdByFilepathOrFirstLine(resource, firstLine);
    }

    public getLanguageIdentifier(modeId) {
        return ModeService.getModeService().getLanguageIdentifier(modeId);
    }

    public create(commaSeparatedMimetypesOrCommaSeparatedIds: string) {
        return ModeService.getModeService().create(commaSeparatedMimetypesOrCommaSeparatedIds);
    }

    public createByLanguageName(languageName: string) {
        return ModeService.getModeService().createByLanguageName(languageName);
    }

    public createByFilepathOrFirstLine(resource: URI | null, firstLine?: string) {
        return ModeService.getModeService().createByFilepathOrFirstLine(resource, firstLine);
    }
}

